<div class="img" [class.cover]="imageCover()">
  <ion-img [src]="imgSrc()" [alt]="alt()" (ionError)="onLoadFail()" />
</div>
